<template>
  <router-view />
</template>

<script>
export default {
  name: 'PersonalInterestRate'
}
</script>

<style scoped>

</style>
